import React, { useState } from 'react';
import { Modal } from 'antd';

const useModal = (isMultiple = false) => {
    const [modals, setModals] = useState([]);

    const openModal = (id) => {
        setModals((prevModals) => {
            // If the modal with the given ID is already open, return the current state
            if (prevModals.includes(id)) {
                return prevModals;
            }
            // Otherwise, add the modal ID to the state
            return [...prevModals, id];
        });
    };

    const closeModal = (id) => {
        setModals((prevModals) => prevModals.filter(modalId => modalId !== id));
    };

    const ModalComponent = ({ id, children, className, closeIcon }) => {
        return (
            <Modal
                open={modals.includes(id)}
                onCancel={() => closeModal(id)}
                footer={null}
                className={className}
                closeIcon={closeIcon}
                maskClosable={false}
                centered={true}
            >
                {children}
            </Modal>
        );
    };

    return {
        openModal,
        closeModal,
        ModalComponent
    };
};

export default useModal;